// @ts-nocheck
///
/// Fix for editor reference as it relates to next.js => https://github.com/zeit/next.js/issues/4957
///

import React from 'react';
import Router, { useRouter } from 'next/router';
import Fetch from '@/utils/Fetch';
import SettingsMenu from '@/components/settings/menu';
import Helper from '@/utils/helper';
import EditTemplateV2 from "@/PageComponents/Settings/Template/EditTemplateV2";
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router'

function TemplatePage() {

  const router = useRouter();
  const { id } = router.query;
 // TODO(tanstack-router): verify router.query → useParams/useSearch

  let currPath = '';
  if (Router.router) {
    currPath = Router.router.asPath;
  }

  const queryClient = useQueryClient();

  const { data: fetchedTemplate } = useQuery(
    ['template', id],
    () => Fetch.get({ url: '/Template', params: { id } }),
    { enabled: !!id }
  );

  // Render from a held copy rather than directly off the query. Template saves are
  // versioned (each save returns a new ID), so after a save we replace the route id.
  // Driving the editor straight off the query would briefly hand it the previous
  // version — or undefined during the key swap — which remounts EditTemplateV2 with
  // stale data and reverts the form. Holding the latest known template (and setting
  // it to the saved record synchronously on save) keeps the editor stable across the swap.
  const [template, setTemplate] = React.useState<any>(null);

  // After a save we optimistically show the new version while the route id swaps to it.
  // During that swap the old-id query can briefly re-emit its (now superseded) record
  // because of staleTime/cacheTime: 0 + the router's one-render param lag. Pin to the
  // saved id and ignore any query result for a different version until the route catches
  // up, otherwise that stale record would be re-adopted and flash the editor back to the
  // old content for a frame.
  const pendingSavedIdRef = React.useRef<string | null>(null);

  React.useEffect(() => {
    if (!fetchedTemplate) return;
    if (pendingSavedIdRef.current && fetchedTemplate.ID !== pendingSavedIdRef.current) {
      return;
    }
    pendingSavedIdRef.current = null;
    setTemplate(fetchedTemplate);
  }, [fetchedTemplate]);

  const onCancel = () => {
    Helper.nextRouter(Router.push, `/settings/template/list`);
  };

  // Template saves are versioned: each save yields a new ID, so the route's id
  // becomes stale and a refresh/back/direct-nav would fetch the superseded version.
  // Show the saved version immediately, prime the cache for its new ID, then update
  // the URL client-side (no reload) so later navigations resolve the latest version.
  const onSaved = (saved: any) => {
    if (!saved?.ID) return;
    pendingSavedIdRef.current = saved.ID;
    setTemplate(saved);
    queryClient.setQueryData(['template', saved.ID], saved);
    Helper.nextRouter(Router.replace, `/settings/template/${saved.ID}`);
  };

  if (!template) return null;

  return (
    <div className="settings-container">
      {/*<div className="row">
        <div className="title">
          <Breadcrumbs
            crumbs={[
              { text: 'Settings', link: '', suppressLink: true },
              { text: 'Templates', link: '/settings/template/list' },
              { text: `${props.template.Name}`, link: '' },
            ]}
          />
        </div>
        <div className="actions">

        </div>
      </div>*/}
      <div className="row">
        <SettingsMenu urlPath={currPath} />
        <div className="settings-card">
          <EditTemplateV2 template={template} fromCreate={false} fromExternalModule={false} onCancel={onCancel} onSaved={onSaved} />
        </div>
      </div>

      <style jsx>{`
        .row {
          display: flex;
        }
        .column {
          display: flex;
          flex-basis: 0;
          flex-direction: column;
          flex-grow: 1;
        }
        .column :global(.textarea-container) {
          height: 100%;
        }
        .column + .column {
          margin-left: 1.25rem;
        }
        .column-end {
          align-items: flex-end;
        }
        .image-button {
          cursor: pointer;
        }
        .joditContainer {
          position: relative;
        }
        .note {
          margin-top: 1rem;
        }
        .tagSelector {
          position: absolute;
          right: 1rem;
          top: 3rem;
        }
        .tagSelectorNoToolbar {
          position: absolute;
          right: 1rem;
          top: 1rem;
        }
        .actions {
          display: flex;
        }
        .actions :global(.button){
          margin-left: 0.5rem;
          margin-top: 0;
          padding: 0 1rem;
          white-space: nowrap;
        }

      `}</style>
    </div>
  );
}

export default TemplatePage;

export const Route = createFileRoute('/_authenticated/settings/template/$id')({ component: TemplatePage })
